/**
* DevExpress HTML/JS Reporting (common\exportOptions\xlsxMetaData.js)
* Version:  23.1.4
* Build date: Jul 18, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { xlsxExportMode } from './metadata';
import { xlsExportOptionsSerializationInfoCommon } from './xlsMetaData';
export var xlsxExportOptionsSerializationInfo = [xlsxExportMode].concat(xlsExportOptionsSerializationInfoCommon);
